<div [phInnerHTML]="html"></div>
